<ada-container
	horizontalSpacing="medium"
	padding="{{ ui.Spacing.SPACING_LARGE }}"
	verticalSpacing="medium"
	[colCount]="4"
>
	@if (errorMessage | async; as _err) {
		<ada-alert
			type="error"
			[colSpan]="4"
			[isClosable]="false"
			[title]="_err"
		/>
	}

	<ada-label
		content="Email Address"
		[isRequired]="true"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	/>
	<ada-input
		#ForgotPasswordEmailInput
		data-testid="login-form-forgot-password-email-input"
		type="email"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="context"
	/>
</ada-container>
